import React, {useState, useEffect} from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import ContentHeading from '../../components/contentHeading/contentHeading';
import ContentHeadingButton from '../../components/contentHeading/contentHeadingButton';
import TableView from '../../components/tableView/tableView';
import { authFetch } from '../../components/authFetch/authFetch'
import { Throbber } from '../../components/throbber/throbber'
import { SlEnvolope } from "react-icons/sl";
import { Link } from 'react-router-dom';

const Campaign = () => {
    const navigate = useNavigate();
    const [campaigns, setCampaigns] = useState([]);
    const [statusState, setStatusState] = useState('loading');

    const headings = {
        Campaign: 'Campaign',
        Type: 'Type',
        Status: 'Status',
        LastUpdated: 'Last Updated',
        OpenRate: 'Open Rate',
        ClickRate: 'Click Rate',
        Deliveries: 'Deliveries'
        // EmailPreview: 'Preview'
    };

    const formatCampaignData = (data) => {
        if (!data || !Array.isArray(data)) {
            console.error("formatCampaignData received invalid data:", data);
            return [];  // ✅ Return an empty array to prevent errors
        }

        return data.map((campaign) => ({
            Campaign: <Link to={`/campaign/detail?id=${campaign.id}`} style={{ color: "black"}}>{campaign.name}</Link>,
            Type: campaign.campaign_type || "Unknown",
            Status: campaign.status || "Unknown",
            LastUpdated: campaign.last_updated 
                ? new Date(campaign.last_updated).toLocaleDateString() 
                : "N/A",
            OpenRate: campaign.open_rate !== undefined ? `${(campaign.open_rate * 100).toFixed(2)}%` : "N/A",
            ClickRate: campaign.click_rate !== undefined ? `${(campaign.click_rate * 100).toFixed(2)}%` : "N/A",
            Deliveries: campaign.deliveries !== undefined ? `${(campaign.deliveries).toFixed(2)}` : "N/A"
        }));
    };

    const handleCreateCampaign = () => {
        navigate('/create-campaign/email');
    };

    useEffect(() => {
        authFetch({
            apiMethod: "GET",
            endpoint: "/campaign",
            onDataLoaded: (data) => {
                setStatusState("success");
                setCampaigns(formatCampaignData(data?.campaigns));
            }, 
            onErrorResponse: () => {
                setStatusState("error");
                console.log("error");
            }
        });
    }, []);

    return (
        <div className='campaign-home-container'>
            {statusState == "loading" && (
                <div className="throbber-overlay">
                    <Throbber />
                </div>
            )}

            <ContentHeading action={
                 <ContentHeadingButton handleContentHeadingButton={handleCreateCampaign} buttonStyleClass="create-button" buttonName="Create Campaign" />
            } heading="Campaigns" />

            <TableView headings={headings} data={campaigns}/>
        </div>
    );
};

export { Campaign };
